import React from "react";

const Footer = () => {
  return (
    <footer className="py-5 bg-dark">
      <div className="container">
        <p className="m-0 text-center text-white">
          Copyright © Your Website 2019
        </p>
      </div>
    </footer>
  );
};

export default Footer;
